import React from "react";
import Navbar from "./components/navbar";
import CreateIcali2Component from "./create/create.component";
import CreateIcali2Provider from "./create/provider/createIcali2.provider";
import CreateUsedIcali2Provider from "./create/used/provider/createUsedIcali2.provider";
import CreateNewsIcali2Provider from "./create/news/provider/createNewsIcali2.provider";

const Icali2Page = () => {
  return (
    <CreateIcali2Provider>
      <CreateNewsIcali2Provider>
        <CreateUsedIcali2Provider>
          <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#2D1366]">
            <Navbar />
            <section className="flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateIcali2Component />
              </div>
            </section>
          </div>
        </CreateUsedIcali2Provider>
      </CreateNewsIcali2Provider>
    </CreateIcali2Provider>
  );
};

export default Icali2Page;
